module.exports = __webpack_public_path__ + "static/Drupal_Association-8de5bcf6f8b612b5db16bf29f8d7c9c3.png";